import Animation from './Animation'
import * as Actions from './actions/actions'

export default class Animator {
    constructor(settings, raf) {
        this._settings = settings;
        this._cancel = {};
        this._raf = raf || (cb => window.requestAnimationFrame(cb));
    }

    getReducer() {
         return reducer;
    }

    initialize(store) {
        this._store = store;
    }

    extractValueAndUnits(str) {
        if (typeof str != 'string' && typeof str != 'number') return;
        str = (''+str).trim();

        let value = parseFloat(str);
        if (isNaN(value)) return;
        
        let units = str.substr((''+value).length).trim();

        return { value, units };
    }

    validateAnimation(animation) {
        let err = null, element = null;

        (({ selector, duration, attributes }) => {
            if (!selector)
                return ("Invalid selector!")
            if (!duration) 
                return ("Invalid duration!")
            if (!attributes || !Object.keys(attributes).length) 
                return ("No attributes specified!")
            
            element = document.querySelector(selector)
            if (!element) 
                return (`No elements found for selector '${selector}'`);
        })(animation);

        if (err) throw new Error(err);
        return element;
    }

    validateAttributes(attributes, element) {
        let startAttr = {}, targetAttr = {};
        let computed = getComputedStyle(element);

        for (let key in attributes) {
            let current = this.extractValueAndUnits(computed[key]);
            let target = this.extractValueAndUnits(attributes[key]);

            if (!current)
                throw new Error(`Could not parse computed element attribute:${key}`)
            if (!target)
                throw new Error(`Could not parse target attribute:${key}`);
            if (current.units != target.units) 
                throw new Error("Animation error - units don't match");

            startAttr[key] = current;
            targetAttr[key] = target;
        }

        return { startAttr, targetAttr };
    }

    setupCancel(selector, animation) {
        // Cancel the old one, if running
        if (this._cancel[selector]) this._raf(this._cancel[selector]);

        let cancel = () => { animation.running = false; };
        this._cancel[selector] = cancel;

        return () => { this._cancel[selector] = (void 0) };
    }

    start(definition) {
        let el = this.validateAnimation(definition);
        let { selector, duration, attributes, callback } = definition;
        let { startAttr, targetAttr } = this.validateAttributes(attributes, el);

        let animation = new Animation(el, { 
            selector, startAttr, targetAttr, duration 
        }, this._raf);

        let clearCancel = this.setupCancel(selector, animation);
        let animCb = () => {
            clearCancel();
            if (typeof callback == 'function') {
                callback();
            }
        }

        animation.setCallback(animCb);
        animation.start();
    }
}



// WEBPACK FOOTER //
// ./src/nextit-animator-raf.js


// WEBPACK FOOTER //
// webpack:///src/nextit-animator-raf.js